import styled from 'styled-components'
import theme from '../theme'
import { RelSize, Ratio } from '../mixins'
import { lighten } from 'polished'
import NavigationIconStyled from '../icons/navigation';
import { HelpWrapperStyled } from '../forms/inputs';
import { CandidateStatus } from '../../_enums/candidateStatus.enum';
import NotificationIcon from '../icons/notificationIcon';
import { CopyLink } from '../type/typography';

const BaseBlock = styled.div`
	border: 1px solid ${theme.borderGrey};
    position: relative;
`;

export const ContentBlockStyled = styled(BaseBlock)`
    margin-bottom: ${RelSize(20, 16)};
    padding: ${RelSize(20, 16)};
    p, a {
        font-size: ${RelSize(14, 16)};
        font-weight: 400;
        line-height: ${Ratio(14)};
        &:last-of-type {
            margin: 0;
        }
        p, a {
            font-size: 1em;
            line-height: ${Ratio(14)};
        }
    }
    a {
        font-weight: 700;
    }
`;

export const IntroductionBlockStyled = styled.div`
    margin-bottom: ${RelSize(30, 16)};
`;

export const DashboardBlockWrapper = styled.div`
	display: grid; 
	grid-template-rows: 1fr 1fr;
   	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: ${RelSize(20, 16)};
	${props => props.items === 1 && `
		> div:nth-child(1) {
			grid-row-start: 1;
			grid-column-start: 1;
			grid-row-end: 3;
			grid-column-end: 2;
		}
	`}
	${props => props.items === 2 && `
		> div:nth-child(1) {
			grid-row-start: 1;
			grid-column-start: 1;
			grid-row-end: 3;
			grid-column-end: 2;
		}
		> div:nth-child(2) {
			grid-row-start: 1;
			grid-column-start: 2;
			grid-row-end: 3;
			grid-column-end: 3;
		}
	`}
	${props => props.items === 3 && `
		> div:nth-child(1) {
			grid-row-start: 1;
			grid-column-start: 1;
			grid-row-end: 3;
			grid-column-end: 2;
		}
		> div:nth-child(2) {
			grid-row-start: 1;
			grid-column-start: 2;
			grid-row-end: 3;
			grid-column-end: 3;
		}
		> div:nth-child(3) {
			grid-row-start: 1;
			grid-column-start: 3;
			grid-row-end: 3;
			grid-column-end: 4;
		}
	`}
	${props => props.items === 4 && `
		> div:nth-child(1) {
			grid-row-start: 1;
			grid-column-start: 1;
			grid-row-end: 3;
			grid-column-end: 2;
		}
		> div:nth-child(2) {
			grid-row-start: 1;
			grid-column-start: 2;
			grid-row-end: 3;
			grid-column-end: 3;
		}
		> div:nth-child(3) {
			grid-row-start: 1;
			grid-column-start: 3;
			grid-row-end: 3;
			grid-column-end: 4;
		}
		> div:nth-child(4) {
			grid-row-start: 1;
			grid-column-start: 4;
			grid-row-end: 3;
			grid-column-end: 5;
		}
	`}
	${props => props.items === 5 && `
		> div:nth-child(1) {
			grid-row-start: 1;
			grid-column-start: 1;
			grid-row-end: 2;
			grid-column-end: 2;
		}
		> div:nth-child(2) {
			grid-row-start: 2;
			grid-column-start: 1;
			grid-row-end: 3;
			grid-column-end: 2;
		}
		> div:nth-child(3) {
			grid-row-start: 1;
			grid-column-start: 2;
			grid-row-end: 3;
			grid-column-end: 3;
		}
		> div:nth-child(4) {
			grid-row-start: 1;
			grid-column-start: 3;
			grid-row-end: 3;
			grid-column-end: 4;
		}
		> div:nth-child(5) {
			grid-row-start: 1;
			grid-column-start: 4;
			grid-row-end: 3;
			grid-column-end: 5;
		}
	`}
	${props => props.items === 6 && `
		> div:nth-child(1) {
			grid-row-start: 1;
			grid-column-start: 1;
			grid-row-end: 2;
			grid-column-end: 2;
		}
		> div:nth-child(2) {
			grid-row-start: 2;
			grid-column-start: 1;
			grid-row-end: 3;
			grid-column-end: 2;
		}
		> div:nth-child(3) {
			grid-row-start: 1;
			grid-column-start: 2;
			grid-row-end: 2;
			grid-column-end: 3;
		}
		> div:nth-child(4) {
			grid-row-start: 2;
			grid-column-start: 2;
			grid-row-end: 3;
			grid-column-end: 3;
		}
		> div:nth-child(5) {
			grid-row-start: 1;
			grid-column-start: 3;
			grid-row-end: 3;
			grid-column-end: 4;
		}
		> div:nth-child(6) {
			grid-row-start: 1;
			grid-column-start: 4;
			grid-row-end: 3;
			grid-column-end: 5;
		}
	`}
	@media all and (min-width: 481px) and (max-width: 1024px) {
		display: flex;
		flex-direction: row;
		flex-gap: ${RelSize(10, 16)};
		flex-wrap: wrap;
		> div {
			flex-basis: calc(50% - ${RelSize(10, 16)});
		}
	}
	@media all and (max-width: 480px) {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		> div {
			flex-basis: 100%;
		}
	}
`;

export const DashboardBlockStyled = styled(BaseBlock)`
	background-color: ${theme.quarterinaryGreen};
	background-repeat: no-repeat;
	background-size: cover;
	border: 0;
	border-radius: ${RelSize(10, 16)};
    a {
        align-items: flex-start;
        color: ${theme.backgroundGrey};
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: flex-end;
        min-height: ${RelSize(175, 16)};
        padding: ${RelSize(20, 16)};
        text-decoration: none;
        width: 100%;
    }
    p {
		color: ${theme.backgroundGrey};
        font-size: ${RelSize(18, 16)};
        font-family: "Montserrat", sans-serif;
        font-weight: 700;
        line-height: ${Ratio(18)};
		margin: 0;
    }
	${props => props.image === "leaf1" && `
		background-image: url('/static/images/leaf-1.png');
	`}
	${props => props.image === "leaf2" && `
		background-image: url('/static/images/leaf-2.png');
	`}
	${props => props.image === "leaf3" && `
		background-image: url('/static/images/leaf-3.png');
	`}
	${props => props.image === "leaf4" && `
		background-image: url('/static/images/leaf-4.png');
	`}
`;

export const MarketingStatBlockStyled = styled(BaseBlock)`
	background-color: ${theme.quarterinaryGreen};
	border-radius: ${RelSize(10, 16)};
	cursor: ${props => props.static ? "default" : "pointer"};
	padding: ${RelSize(10, 16)};
	position: relative;
    margin-bottom: ${RelSize(20, 16)};
	text-align: center;
    p {
		color: ${theme.backgroundGrey};
        font-size: ${RelSize(12, 16)};
        font-family: "Montserrat", sans-serif;
        line-height: ${Ratio(12)};
		margin: 0;
		&:last-child {
			font-size: ${RelSize(40, 16)};
			font-weight: 700;
			line-height: ${Ratio(40)};
		}
    }
	${HelpWrapperStyled} {
		top: 5px;
		right: 5px;
	}
`;

export const CandidateStatusWrapper = styled.div`
	display: flex;
	flex-wrap: no-wrap;
	margin-bottom: ${({ flush }) => flush ? 0 : RelSize(20, 16)};
`;

export const CandidateProfilePhoto = styled.div`
	border: 2px solid ${theme.borderGrey};
	border-radius: 50%;
	cursor: pointer;
	height: ${RelSize(100, 16)};
	flex-grow: 0;
	margin-right: ${RelSize(10, 16)};
	overflow: hidden;
	position: relative;
	width: ${RelSize(100, 16)};
`;

export const CandidateTableProfilePhoto = styled.div`
	border: 2px solid ${theme.borderGrey};
	border-radius: 50%;
	height: ${RelSize(75, 16)};
	flex-grow: 0;
	margin: 0;
	overflow: hidden;
	position: relative;
	width: ${RelSize(75, 16)};
`;

export const CandidateStatusBlockStyled = styled.div`	
	align-self: flex-start;
	border-radius: ${RelSize(10, 16)};
	margin-bottom: ${RelSize(10, 16)};
	margin-top: ${props => props.pushTop ? RelSize(50, 16) : 0};
    padding: ${RelSize(5, 16)} ${RelSize(5, 16)} ${RelSize(5, 16)} ${RelSize(35, 16)};
	width: 100%;
    p, a {
		font-size: ${RelSize(14, 16)};
        font-weight: 700;
        line-height: ${Ratio(14)};
        &:last-of-type {
            margin: 0;
        }
        p, a {
            font-size: 1em;
        }
    }
	a {
		text-decoration: underline;
	}
	${props => (props.status == 1 || props.status == 7 || props.status == 8) && `
		background-color: ${lighten(0.4, theme.trafficLightBlue)};
		background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iRXhjbHVzaW9uXzUiIGRhdGEtbmFtZT0iRXhjbHVzaW9uIDUiIGQ9Ik0tMjM1Mi0xMDQ3YTkuOTM5LDkuOTM5LDAsMCwxLTMuODkzLS43ODYsOS45NjQsOS45NjQsMCwwLDEtMy4xNzgtMi4xNDMsOS45NjUsOS45NjUsMCwwLDEtMi4xNDMtMy4xNzlBOS45MzgsOS45MzgsMCwwLDEtMjM2Mi0xMDU3YTkuOTM5LDkuOTM5LDAsMCwxLC43ODYtMy44OTMsOS45NjMsOS45NjMsMCwwLDEsMi4xNDMtMy4xNzksOS45NjksOS45NjksMCwwLDEsMy4xNzgtMi4xNDNBOS45MzksOS45MzksMCwwLDEtMjM1Mi0xMDY3YTkuOTM3LDkuOTM3LDAsMCwxLDMuODkyLjc4Niw5Ljk2OSw5Ljk2OSwwLDAsMSwzLjE3OCwyLjE0Myw5Ljk2Myw5Ljk2MywwLDAsMSwyLjE0MywzLjE3OUE5LjkzOSw5LjkzOSwwLDAsMS0yMzQyLTEwNTdhOS45MzgsOS45MzgsMCwwLDEtLjc4NiwzLjg5Miw5Ljk2MSw5Ljk2MSwwLDAsMS0yLjE0MywzLjE3OSw5Ljk2NSw5Ljk2NSwwLDAsMS0zLjE3OCwyLjE0M0E5LjkzNyw5LjkzNywwLDAsMS0yMzUyLTEwNDdabTEuNTQxLTEyLjQyOWgwbC0uNjg4LjEzM2MtLjI0Mi4wNDctLjY1My4xLTEuMjIzLjE2OHMtMS4wMS4xMDgtMS4zMTcuMTI5di40MjJhMi43MTcsMi43MTcsMCwwLDEsLjc0Mi4xYy4xMzUuMDUyLjIuMTg2LjIuNGEuNjA2LjYwNiwwLDAsMS0uMDEyLjExN2MtLjAwOC4wNDItLjAxNy4wODMtLjAyOC4xMjVsLS45NjEsMy41OTRjLS4wNzQuMjctLjEyOC40OC0uMTY0LjY0MWEzLjIyMiwzLjIyMiwwLDAsMC0uMDk0LjYxNy45ODEuOTgxLDAsMCwwLC4zNDcuODI0LDEuMjU0LDEuMjU0LDAsMCwwLC43ODUuMjcsMi4wNzksMi4wNzksMCwwLDAsMS40NTMtLjY1NiwxMSwxMSwwLDAsMCwxLjItMS41NDdsLS4zNTItLjIyN2E2LjI4NSw2LjI4NSwwLDAsMS0uNjMzLjg2OGMtLjIzOS4yNzUtLjQ0MS40MTQtLjYuNDE0YS4zMTMuMzEzLDAsMCwxLS4xNzItLjA1MWMtLjA1Mi0uMDM0LS4wNzgtLjEwOS0uMDc4LS4yMjNhNC4yMzYsNC4yMzYsMCwwLDEsLjE0MS0uNzVjLjAzNy0uMTU1LjExLS40MzYuMjExLS44MTJsMS4yNDItNC41NTVabS0uNDQ1LTMuNTcxYTEuMDUsMS4wNSwwLDAsMC0uNzYyLjMxMiwxLjAzLDEuMDMsMCwwLDAtLjMxNi43NTgsMS4wNDIsMS4wNDIsMCwwLDAsLjMxNi43NjIsMS4wNDMsMS4wNDMsMCwwLDAsLjc2Mi4zMTcsMS4wMywxLjAzLDAsMCwwLC43NTgtLjMxNywxLjA0OCwxLjA0OCwwLDAsMCwuMzEzLS43NjIsMS4wMzYsMS4wMzYsMCwwLDAtLjMxMi0uNzU4QTEuMDM3LDEuMDM3LDAsMCwwLTIzNTAuOS0xMDYzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM2MiAxMDY3KSIgZmlsbD0iIzJhNjVjYyIvPgo8L3N2Zz4K');
		background-size: 15px 15px;
		background-position: 10px center;
		background-repeat: no-repeat;
		border: 2px solid ${theme.trafficLightBlue};
		color: ${theme.trafficLightBlue};
		a {
			color: ${theme.trafficLightBlue};
		}
	`}
	${props => props.status == 2 && `
		background-color: ${lighten(0.5, theme.trafficLightGreen)};
		background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjIiIGhlaWdodD0iMjYyIiB2aWV3Qm94PSIwIDAgMjYyIDI2MiI+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC42OTEgMC42OTEpIj4KICAgIDxnIGlkPSJFNDA4X1N1Y2Nlc3NfTWVkaWFfbWVkaWFfcGxheWVyX211bHRpbWVkaWEiIGRhdGEtbmFtZT0iRTQwOCwgU3VjY2VzcywgTWVkaWEsIG1lZGlhIHBsYXllciwgbXVsdGltZWRpYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS41ODIgOS41ODIpIj4KICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xIiBkYXRhLW5hbWU9IkVsbGlwc2UgMSIgY3g9IjEyMSIgY3k9IjEyMSIgcj0iMTIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4yNzMgLTAuMjczKSIgZmlsbD0iIzM4OGUzYyIgc3Ryb2tlPSIjMzg4ZTNjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMjAiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMSIgZGF0YS1uYW1lPSJQYXRoIDEiIGQ9Ik0xMTUuNTQsMjEyLjRsNDEuNzY3LDQxLjc2N0wyNTMuMzY1LDE1OC4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjMuNDE5IC04NS4wOTgpIiBmaWxsPSIjMzg4ZTNjIiBzdHJva2U9IiNkNmVmZDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyMCIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==');
		background-size: 15px 15px;
		background-position: 10px center;
		background-repeat: no-repeat;
		border: 2px solid ${theme.trafficLightGreen};
		color: ${theme.trafficLightGreen};
		a {
			color: ${theme.trafficLightGreen};
		}
	`}
	${props => props.status == 3 && `
		background-color: ${lighten(0.4, theme.trafficLightRed)};
		background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iRXhjbHVzaW9uXzUiIGRhdGEtbmFtZT0iRXhjbHVzaW9uIDUiIGQ9Ik0tMjM1Mi0xMDQ3YTkuOTM5LDkuOTM5LDAsMCwxLTMuODkzLS43ODYsOS45NjQsOS45NjQsMCwwLDEtMy4xNzgtMi4xNDMsOS45NjUsOS45NjUsMCwwLDEtMi4xNDMtMy4xNzlBOS45MzgsOS45MzgsMCwwLDEtMjM2Mi0xMDU3YTkuOTM5LDkuOTM5LDAsMCwxLC43ODYtMy44OTMsOS45NjMsOS45NjMsMCwwLDEsMi4xNDMtMy4xNzksOS45NjksOS45NjksMCwwLDEsMy4xNzgtMi4xNDNBOS45MzksOS45MzksMCwwLDEtMjM1Mi0xMDY3YTkuOTM3LDkuOTM3LDAsMCwxLDMuODkyLjc4Niw5Ljk2OSw5Ljk2OSwwLDAsMSwzLjE3OCwyLjE0Myw5Ljk2Myw5Ljk2MywwLDAsMSwyLjE0MywzLjE3OUE5LjkzOSw5LjkzOSwwLDAsMS0yMzQyLTEwNTdhOS45MzgsOS45MzgsMCwwLDEtLjc4NiwzLjg5Miw5Ljk2MSw5Ljk2MSwwLDAsMS0yLjE0MywzLjE3OSw5Ljk2NSw5Ljk2NSwwLDAsMS0zLjE3OCwyLjE0M0E5LjkzNyw5LjkzNywwLDAsMS0yMzUyLTEwNDdabTEuNTQxLTEyLjQyOWgwbC0uNjg4LjEzM2MtLjI0Mi4wNDctLjY1My4xLTEuMjIzLjE2OHMtMS4wMS4xMDgtMS4zMTcuMTI5di40MjJhMi43MTcsMi43MTcsMCwwLDEsLjc0Mi4xYy4xMzUuMDUyLjIuMTg2LjIuNGEuNjA2LjYwNiwwLDAsMS0uMDEyLjExN2MtLjAwOC4wNDItLjAxNy4wODMtLjAyOC4xMjVsLS45NjEsMy41OTRjLS4wNzQuMjctLjEyOC40OC0uMTY0LjY0MWEzLjIyMiwzLjIyMiwwLDAsMC0uMDk0LjYxNy45ODEuOTgxLDAsMCwwLC4zNDcuODI0LDEuMjU0LDEuMjU0LDAsMCwwLC43ODUuMjcsMi4wNzksMi4wNzksMCwwLDAsMS40NTMtLjY1NiwxMSwxMSwwLDAsMCwxLjItMS41NDdsLS4zNTItLjIyN2E2LjI4NSw2LjI4NSwwLDAsMS0uNjMzLjg2OGMtLjIzOS4yNzUtLjQ0MS40MTQtLjYuNDE0YS4zMTMuMzEzLDAsMCwxLS4xNzItLjA1MWMtLjA1Mi0uMDM0LS4wNzgtLjEwOS0uMDc4LS4yMjNhNC4yMzYsNC4yMzYsMCwwLDEsLjE0MS0uNzVjLjAzNy0uMTU1LjExLS40MzYuMjExLS44MTJsMS4yNDItNC41NTVabS0uNDQ1LTMuNTcxYTEuMDUsMS4wNSwwLDAsMC0uNzYyLjMxMiwxLjAzLDEuMDMsMCwwLDAtLjMxNi43NTgsMS4wNDIsMS4wNDIsMCwwLDAsLjMxNi43NjIsMS4wNDMsMS4wNDMsMCwwLDAsLjc2Mi4zMTcsMS4wMywxLjAzLDAsMCwwLC43NTgtLjMxNywxLjA0OCwxLjA0OCwwLDAsMCwuMzEzLS43NjIsMS4wMzYsMS4wMzYsMCwwLDAtLjMxMi0uNzU4QTEuMDM3LDEuMDM3LDAsMCwwLTIzNTAuOS0xMDYzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM2MiAxMDY3KSIgZmlsbD0iI2Y2NjkxOCIvPgo8L3N2Zz4K');
		background-size: 15px 15px;
		background-position: 10px center;
		background-repeat: no-repeat;
		border: 2px solid ${theme.trafficLightRed};
		color: ${theme.trafficLightRed};
		a {
			color: ${theme.trafficLightRed};
		}
	`}
	${props => props.status == 6 && `
		background-color: ${lighten(0.4, theme.trafficLightAmber)};
		background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iRXhjbHVzaW9uXzUiIGRhdGEtbmFtZT0iRXhjbHVzaW9uIDUiIGQ9Ik0tMjM1Mi0xMDQ3YTkuOTM5LDkuOTM5LDAsMCwxLTMuODkzLS43ODYsOS45NjQsOS45NjQsMCwwLDEtMy4xNzgtMi4xNDMsOS45NjUsOS45NjUsMCwwLDEtMi4xNDMtMy4xNzlBOS45MzgsOS45MzgsMCwwLDEtMjM2Mi0xMDU3YTkuOTM5LDkuOTM5LDAsMCwxLC43ODYtMy44OTMsOS45NjMsOS45NjMsMCwwLDEsMi4xNDMtMy4xNzksOS45NjksOS45NjksMCwwLDEsMy4xNzgtMi4xNDNBOS45MzksOS45MzksMCwwLDEtMjM1Mi0xMDY3YTkuOTM3LDkuOTM3LDAsMCwxLDMuODkyLjc4Niw5Ljk2OSw5Ljk2OSwwLDAsMSwzLjE3OCwyLjE0Myw5Ljk2Myw5Ljk2MywwLDAsMSwyLjE0MywzLjE3OUE5LjkzOSw5LjkzOSwwLDAsMS0yMzQyLTEwNTdhOS45MzgsOS45MzgsMCwwLDEtLjc4NiwzLjg5Miw5Ljk2MSw5Ljk2MSwwLDAsMS0yLjE0MywzLjE3OSw5Ljk2NSw5Ljk2NSwwLDAsMS0zLjE3OCwyLjE0M0E5LjkzNyw5LjkzNywwLDAsMS0yMzUyLTEwNDdabTEuNTQxLTEyLjQyOWgwbC0uNjg4LjEzM2MtLjI0Mi4wNDctLjY1My4xLTEuMjIzLjE2OHMtMS4wMS4xMDgtMS4zMTcuMTI5di40MjJhMi43MTcsMi43MTcsMCwwLDEsLjc0Mi4xYy4xMzUuMDUyLjIuMTg2LjIuNGEuNjA2LjYwNiwwLDAsMS0uMDEyLjExN2MtLjAwOC4wNDItLjAxNy4wODMtLjAyOC4xMjVsLS45NjEsMy41OTRjLS4wNzQuMjctLjEyOC40OC0uMTY0LjY0MWEzLjIyMiwzLjIyMiwwLDAsMC0uMDk0LjYxNy45ODEuOTgxLDAsMCwwLC4zNDcuODI0LDEuMjU0LDEuMjU0LDAsMCwwLC43ODUuMjcsMi4wNzksMi4wNzksMCwwLDAsMS40NTMtLjY1NiwxMSwxMSwwLDAsMCwxLjItMS41NDdsLS4zNTItLjIyN2E2LjI4NSw2LjI4NSwwLDAsMS0uNjMzLjg2OGMtLjIzOS4yNzUtLjQ0MS40MTQtLjYuNDE0YS4zMTMuMzEzLDAsMCwxLS4xNzItLjA1MWMtLjA1Mi0uMDM0LS4wNzgtLjEwOS0uMDc4LS4yMjNhNC4yMzYsNC4yMzYsMCwwLDEsLjE0MS0uNzVjLjAzNy0uMTU1LjExLS40MzYuMjExLS44MTJsMS4yNDItNC41NTVabS0uNDQ1LTMuNTcxYTEuMDUsMS4wNSwwLDAsMC0uNzYyLjMxMiwxLjAzLDEuMDMsMCwwLDAtLjMxNi43NTgsMS4wNDIsMS4wNDIsMCwwLDAsLjMxNi43NjIsMS4wNDMsMS4wNDMsMCwwLDAsLjc2Mi4zMTcsMS4wMywxLjAzLDAsMCwwLC43NTgtLjMxNywxLjA0OCwxLjA0OCwwLDAsMCwuMzEzLS43NjIsMS4wMzYsMS4wMzYsMCwwLDAtLjMxMi0uNzU4QTEuMDM3LDEuMDM3LDAsMCwwLTIzNTAuOS0xMDYzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM2MiAxMDY3KSIgZmlsbD0iI2Y2NjkxOCIvPgo8L3N2Zz4K');
		background-size: 15px 15px;
		background-position: 10px center;
		background-repeat: no-repeat;
		border: 2px solid ${theme.trafficLightAmber};
		color: ${theme.trafficLightRed};
		a {
			color: ${theme.trafficLightRed};
		}
	`}
	${props => !props.status && `
		padding: 0;
	`}
`;

export const CandidateStatusActionBlockStyled = styled.div`	
	align-self: flex-start;
	margin-bottom: ${RelSize(10, 16)};
`;

export const CandidateStatusActionDisplayStyled = styled.div`
	align-items: center;
	${({ status }) => {
		switch (status) {
			case CandidateStatus.Pending:
				return `background-color: ${theme.trafficLightBlue};`;
			case CandidateStatus.Approved:
				return `background-color: ${theme.trafficLightGreen};`;
			case CandidateStatus.Rejected:
				return `background-color: ${theme.trafficLightRed};`;
			case CandidateStatus.Enquired:
				return `background-color: ${theme.trafficLightAmber};`;
			case CandidateStatus.Archived:
				return `background-color: ${theme.trafficLightRed};`;
			case CandidateStatus.Anonymised:
				return `background-color: ${theme.trafficLightRed};`;
			case CandidateStatus.Future:
				return `background-color: ${theme.trafficLightBlue};`;
			case CandidateStatus.Pre:
				return `background-color: ${theme.trafficLightBlue};`;
			case CandidateStatus.Hold:
				return `background-color: ${theme.trafficLightBlue};`;
			case CandidateStatus.DNC:
				return `background-color: ${theme.trafficLightRed};`;
			default:
				return `background-color: ${theme.primaryGreen};`;
		}
	}}
	border-radius: ${RelSize(10, 14)};
	color: ${theme.white};
	display: flex;
	font-size: ${RelSize(14, 16)};
	line-height: 1em;
	margin-bottom: ${RelSize(10, 14)};
	margin-right: ${RelSize(10, 14)};
	padding: ${RelSize(10, 14)};
	${NotificationIcon} {
		margin-right: ${RelSize(10, 14)};
	}
`;

export const CandidateStatusActionDisplayWrapperStyled = styled.div`
	align-items: center;
	display: flex;
	${CopyLink} {
		color: ${theme.secondaryGrey};
    	font-size: ${RelSize(14, 16)};
		text-decoration: underline;
	}
	${({ collapse }) => collapse === "sm" && `
		@media all and (max-width: 768px) {
			align-items: flex-start;
			flex-direction: column;
		}
	`}
`;

export const CandidateStatusActionTextStyled = styled.div`
	color: ${theme.secondaryGrey};
    font-size: ${RelSize(14, 16)};
	p {
		margin: 0;
	}
	a {
		color: inherit;
		text-decoration: underline;
	}
`;

export const BlockImage = styled.div`
    max-width: ${props => props.full ? "100%" : RelSize(50, 16)};
    margin-bottom: ${props => props.full ? 0 : RelSize(10, 16)};
    svg, img {
        display: block;
        width: 100%;
        ${props => props.client && `
            max-height: 100%;
            max-width: 100%;
            width: auto;
        `};
    }
	${NavigationIconStyled} {
		height: 100%;
		width: 100%;
	}
`;

export const FloatingContentSection = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	@media all and (min-width: 1025px) {
		min-height: ${({ small }) => small ? `calc(50vh - ${RelSize(98, 16)})` : `calc(100vh - ${RelSize(98, 16)})`};
	}
`;

export const FloatingBlock = styled.div`
	background-color: ${props => props.clear ? "transparent" : theme.backgroundGrey};
	border-radius: ${props => props.clear ? 0 : RelSize(20, 16)};
	box-shadow: 0 ${props => props.clear ? 0 : RelSize(3, 16)} ${props => props.clear ? 0 : RelSize(30, 16)} rgba(0, 0, 0, 0.2);
	padding: ${props => props.clear ? 0 : RelSize(20, 16)};
	@media all and (min-width: 769px) {
		width: ${RelSize(400, 16)};
	}
	@media all and (max-width: 768px) {
		width: 100%;
	}
`;

export const AnimatedBlock = styled.div`
	opacity: ${props => props.animate ? 1 : 0};
	transition: opacity ease-in .5s;
	transition-delay: ${props => props.delay ? ".5s" : ".2s"};
	${props => props.fillSpace && `
		width: 100%;
	`}
	@media all and (max-width: 768px) {
		transition-delay: .2s;
	}
	img {
		display: block;
		width: 100%;
	}
`;

export const VideoWrapper = styled.div`
	@media all and (max-width: 1024px) {
		margin-top: ${RelSize(75, 16)};
	}
	video {
		display: block;
		max-width: 100%;
	}
	#videoContainer {
		border-radius: ${RelSize(50, 16)};
		overflow: hidden;
		padding: 0;
		position: relative;
		@media all and (min-width: 1025px) {
			margin: 0;
		}
		@media all and (max-width: 1024px) {
			border-radius: ${RelSize(20, 16)};
		}
		@media all and (max-width: 768px) {
			margin: 0;
		}
	}
	#controls {
		align-items: center;
		bottom: ${RelSize(30, 16)};
		color: ${theme.primaryGreen};
		display: flex;
		position: absolute;
		right: ${RelSize(30, 16)};
		@media all and (max-width: 1024px) {
			bottom: auto;
			top: ${RelSize(15, 16)};
			right: ${RelSize(15, 16)};
		}
		button {
			background: none;
			box-shadow: none;
			border: none;
			cursor: pointer;
			padding: 0;
			&:not(:last-child) {
				margin-right: ${RelSize(10, 16)};
			}
		}
		i {
			color: ${theme.primaryGreen};
			display: block;
			height: ${RelSize(30, 16)};
			width: ${RelSize(30, 16)};
			@media all and (max-width: 1024px) {
				height: ${RelSize(20, 16)};
				width: ${RelSize(20, 16)};
			}
			svg {
				display: block;
				height: 100%;
				width: 100%;
			}
		}
	}
`;

export const FloatingContentBlock = styled.div`
	padding: ${RelSize(50, 16)} 0;
`;

export const StatBlockStyled = styled(BaseBlock)`
	background-color: ${props => props.active ? theme.white : theme.secondaryGreen};
	border-radius: ${RelSize(10, 16)};
	border:  ${props => props.active ? `2px solid ${theme.secondaryGreen}` : null};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
    margin-bottom: ${RelSize(20, 16)};
    min-height: ${RelSize(175, 16)};
    padding: ${RelSize(20, 16)};
	position: relative;
    > p {
		color: ${props => props.active ? theme.secondaryGreen : theme.tertiaryGreen};
        &:first-child {
            font-size: ${RelSize(20, 16)};
            font-family: "Montserrat", sans-serif;
            font-weight: 700;
            line-height: ${Ratio(20)};
            margin-bottom: ${RelSize(10, 20)};
        }
        &:last-child {
            font-size: ${RelSize(30, 16)};
            font-family: "Montserrat", sans-serif;
            font-weight: 700;
            line-height: ${Ratio(30)};
            margin-bottom: 0;
        }
        span {
            display: block;
            font-size: ${RelSize(10, 20)};
            font-weight: 400;
        }
    }
	${props => props.first && `
		background-image: url('/static/images/stat-leaf-1.png');
		background-repeat: no-repeat;
		background-position: 100% 0;
	`}
	${props => props.last && `
		background-image: url('/static/images/stat-leaf-2.png');
		background-repeat: no-repeat;
		background-position: 100% 100%;
	`}
    &::after {
        left: -1px;
        right: -1px;
    }
	.statGroup {
		display: flex;
		align-items: center;
		> div {
			p {
				color: ${props => props.active ? theme.secondaryGreen : theme.tertiaryGreen};
				font-size: ${RelSize(30, 16)};
				font-family: "Montserrat", sans-serif;
				font-weight: 700;
				line-height: ${Ratio(30)};
				margin: 0;
				position: relative;
				span {
					display: block;
					font-size: ${RelSize(10, 30)};
					font-weight: 400;
					line-height: 0;
					white-space: nowrap;
				}
			}
			a {
				color: ${props => props.active ? theme.secondaryGreen : theme.tertiaryGreen};
				font-family: "Montserrat", sans-serif;
				font-weight: 700;
				line-height: ${Ratio(30)};
			}
			&:not(:last-child) {
				margin-right: ${RelSize(20, 16)};
			}
		}
		&.help {
			> div {
				p {
					padding-right: 50px;
				}
			}
		}
		&.withPagination {
			position: relative;
		}
		.navigation-buttons {
			display: flex;
			top: -${RelSize(20, 16)};
			position: absolute;
			right: 0;
			button {
				align-items: center;
				background: none;
				border: none;
				color: ${theme.tertiaryGreen};
				cursor: pointer;
				display: flex;
				justify-content: center;
				height: ${RelSize(20, 16)};
				padding: 0;
				width: ${RelSize(20, 16)};
				svg {
					display: block;
					height: 100%;
					width: 100%;
				}
			}
		}
	}
	> div.statLoading {
		display: flex;
		justify-content: center;
	}
	sup {
		font-size: ${RelSize(10, 16)};
	}
	${HelpWrapperStyled} {
		right: 10px;
		top: 10px;
	}
`;

export const Sup = styled.span`
	bottom: ${RelSize(10, 16)};
	color: ${theme.tertiaryGreen};
	font-size: ${RelSize(10, 16)};
	line-height: 1em;
	position: absolute;
	right: ${RelSize(10, 16)};
`;

export const ExternalContentBlock = styled.div`
	min-height: calc(100vh - ${RelSize(180, 16)});
`;

export const Quote = styled.div`
	padding-left: ${RelSize(100, 16)};
	position: relative;
	margin-top: 20px;
	&::before {
		background-image: url("data:image/svg+xml;base64,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");
		background-repeat: no-repeat;
		background-size: contain;
		background-position: 0 0;
		content: "";
		height: ${RelSize(60, 16)};
		left: 0;
		position: absolute;
		top: 0;
		width: ${RelSize(83, 16)};
	}
	figure {
		margin: 0;
		padding: 0;
	}
	blockquote {
		font-family: 'Poppins', sans-serif;
		margin: 0;
		padding: 0;	
		p {
			color: ${theme.secondaryGrey};
			font-size:  ${RelSize(20, 16)};
			line-height:  ${RelSize(30, 20)};
			margin: 0;
			padding: 0;
			border-top: 1px solid ${theme.primaryGreen};
			padding-top: 20px;
		}
	}
	figcaption {
		color: ${theme.primaryGreen};
		font-size: ${RelSize(36, 16)};
		font-weight: 700;
		margin-top: ${RelSize(20, 36)};
		cite {
			display: block;
			font-size: ${RelSize(16, 36)};
			font-style: normal;
			font-weight: 700;
			margin-top: ${RelSize(10, 16)};
		}
	};
	&:not(:last-child) {
		margin-bottom: ${RelSize(50, 16)};
	}
`;